bcl.s.formWSE = {
  props: {
    cssSelector: "formWSE-JS",
    buttonSendSelector: "button-send-JS",
  },
  preInit: function () {
    bcl.u.docReady(bcl.s.formWSE.init);
  },
  init: function (baseDom) {
    const baseFind = baseDom ? baseDom : document,
      $containers = baseFind.getElementsByClassName(bcl.s.formWSE.props.cssSelector);

    if (!$containers) {
      return;
    }

    bcl.u.forEach($containers, bcl.s.formWSE.initForm);
  },

  initForm: function ($form) {
    const $button = $form.querySelector("." + bcl.s.formWSE.props.buttonSendSelector);

    if (!$button) {
      return;
    }

    $button.addEventListener("click", function () {
      bcl.s.form.checkForm($form);
      bcl.s.form.clickSend($form);
    });
  },
};

bcl.preInit.push(bcl.s.formWSE.preInit);
